<template>
    <el-dialog
        :close-on-click-modal="false"
        :visible.sync="show"
        align-center
        class="payino-dialog"
        width="450px"
        @open="resetScroll"
        @close="close()"
    >
        <div class="payinfo-form">
            <div class="modal">
                <div class="form">
                    <div class="separator">
                        <hr class="line">
                        <p>pay using credit card</p>
                        <hr class="line">
                    </div>
                    <div class="credit-card-info--form">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <!-- 持卡人名 -->
                                <div class="input_container">
                                    <label class="input_label" for="first_name">THE FIRST NAME</label>
                                    <input id="first_name" v-model="formData.firstName" class="input_field"
                                           name="input-name" placeholder="Enter your first name" title="Inpit title"
                                           type="text">
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <!-- 持卡人姓 -->
                                <div class="input_container">
                                    <label class="input_label" for="last_name">THE LAST NAME</label>
                                    <input id="last_name" v-model="formData.lastName" class="input_field"
                                           name="input-name" placeholder="Enter your last name" title="Inpit title"
                                           type="text">
                                </div>
                            </el-col>
                        </el-row>
                        <!-- 持卡人电话 -->
                        <div class="input_container">
                            <label class="input_label" for="phone">THE MOBILE</label>
                            <input id="phone" v-model="formData.phone" class="input_field"
                                   name="input-name"
                                   placeholder="Enter your phone number" title="Inpit title" type="number">
                        </div>
                        <!-- 国家代码简称 -->
                        <div class="input_container">
                            <label class="input_label" for="country">Country</label>
                            <el-select v-model="formData.country" placeholder="Please select">
                                <el-option
                                    v-for="item in countryData"
                                    :key="item.altSpellings"
                                    :label="item.name_en"
                                    :value="item.altSpellings">
                                </el-option>
                            </el-select>
                        </div>
                        <!-- 签收洲 -->
                        <div v-if="['US', 'CA'].includes(formData.country.toUpperCase())" class="input_container">
                            <label class="input_label" for="state">State</label>
                            <el-select v-model="formData.state" placeholder="Please select">
                                <el-option
                                    v-for="item in stateData"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                                </el-option>
                            </el-select>
                        </div>
                        <!-- 城市 -->
                        <div class="input_container">
                            <label class="input_label" for="city">City</label>
                            <input id="city" v-model="formData.city" class="input_field"
                                    name="input-name" placeholder="Enter your city" title="Inpit title"
                                    type="text">
                        </div>
                        <div class="input_container">
                            <label class="input_label" for="email">Email</label>
                            <input id="email" v-model="formData.email" class="input_field"
                                   name="input-name" placeholder="Enter your email" title="Inpit title" type="text">
                        </div>
                        <!-- 详情地址 -->
                        <div class="input_container">
                            <label class="input_label" for="address">Address</label>
                            <input id="address" v-model="formData.address" class="input_field"
                                   name="input-name" placeholder="Enter your address" title="Inpit title" type="text">
                        </div>
                        <!-- 账单邮编 -->
                        <div class="input_container">
                            <label class="input_label" for="zip">Zip code</label>
                            <input id="zip" v-model="formData.zip" class="input_field" name="input-name"
                                   placeholder="Enter your zip" title="Inpit title" type="text">
                        </div>
                    </div>
                    <button class="purchase--btn" @click="confirm()">Checkout</button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { area } from './area.js'
export default {
    props: {
        show: {
            require: true,
            default: false
        }
    },
    data() {
        return {
            countryData: [], // 国家代码简称
            stateData: [], // 签收洲

            rules: [
                {key: 'email', errMsg: 'Please enter email'},
                {key: 'firstName', errMsg: 'Please enter first name'},
                {key: 'lastName', errMsg: 'Please enter last name'},
                {key: 'phone', errMsg: 'Please enter phone'},
                {key: 'country', errMsg: 'Please select country'},
                //{key: 'state', errMsg: 'Please enter state'},
                {key: 'city', errMsg: 'Please enter city'},
                {key: 'address', errMsg: 'Please enter address'},
                {key: 'zip', errMsg: 'Please enter zip'},
            ],
            formData: {
                email: '',
                firstName: '',
                lastName: '',
                phone: '',
                country: '',
                state: '',
                city: '',
                address: '',
                zip: '',
            },
        }
    },
    /**
     * Lifecycle hook that is called after the instance has been created.
     * It invokes the `getCountryCode` method to fetch the country code upon component creation.
     */
    created() {
        this.getCountryCode()
    },
    watch: {
        'formData.country': {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.stateData = area[newVal]
                } else {
                    this.stateData = []
                }
                this.formData.state = ''
            },
            immediate: true
        }
    },
    methods: {
        // 1. 弹窗打开时重置页面滚动（从根源减少top负值）
        resetScroll() {
            // 强制页面滚到顶部，让select坐标计算基准正常
            const dialogApp = document.querySelector('#app');
            if (dialogApp) dialogApp.scrollIntoView()
        },
        confirm() {
            for (let index = 0; index < this.rules.length; index++) {
                const rule = this.rules[index];
                if (this.formData[rule.key] === '') {
                    this.$message.error(rule.errMsg)
                    return
                }
            }
            this.$emit('confirm', this.formData)
        },
        getCountryCode() {
            this.$http.get('/config/getCountrys').then(res => {
                this.countryData = res.data
            })
        },
        close() {
            this.formData = this.$options.data().formData
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>